// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"86afab93","205":"390e3162","529":"86afab93","622":"86afab93","852":"86afab93"}[chunkId] + ".chunk.css";
};